import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Card, Col, Row, Badge, FormLabel, } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flex from '../../../../../components/common/Flex';
import FalconCardHeader from '../../../../../components/common/FalconCardHeader';
import { useAppContext } from '../../../../../providers/AppProvider';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import IconButton from '../../../../../components/common/IconButton';

const Project = ({ project, isLast, onSelectParadaNoAuth, highlighted }) => {
    const { color, progress, totalAlertsEvent, title } = project;
    const style = {
        display: "-webkit-box",
        WebkitLineClamp: 1, // Limita a 2 líneas
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "normal",
    };
    return (
        <div>
            <Row
                className={classNames(
                    'position-relative align-items-center py-2 ps-3 g-0 flex-nowrap',
                    { 'border-bottom border-200': !isLast },
                    { 'text-danger fw-bold': highlighted }
                )} style={{ minWidth: '350px' }} href="#!" onClick={(e) => {
                    e.preventDefault();
                    onSelectParadaNoAuth(project.tipo_alerta, project.title)
                }}
            >
                <Col className="py-1 px-3 ps-x1 overflow-auto">
                    <Flex className="justify-content-between" >
                        <Row className='mx-0 px-0' style={{ width: '40%' }}>
                            <Flex className={classNames(
                                'm-0 p-0 align-items-center text-truncate flex-grow-1 flex-nowrap',
                                { 'fw-bold': highlighted }
                            )} tag="h6" style={{ ...style }}>
                                <a className={classNames('label-detail-card px-0 mx-0', {
                                    'fw-bold': highlighted
                                })}
                                    style={{ fontSize: '14px', ...style, }}
                                    title={title}>
                                    {title}
                                </a>
                            </Flex>
                        </Row>
                        <Row className="justify-content-end text-end mx-2 g-0 flex-nowrap justify-content-between" style={{ width: '60%', minWidth: '280px' }} >

                            <div className="justify-content-between d-flex flex-nowrap">

                                <div className='mx-2 text-start text-primary'>
                                    {totalAlertsEvent} no autorizadas
                                </div>
                                <Badge pill bg="200">
                                    <div className="m-0 fs-10 fw-semibold text-primary"> {progress}%</div>
                                </Badge>
                                <a className="ms-2 text-800" >
                                    <FontAwesomeIcon icon={faArrowRight} />
                                </a>
                            </div>
                        </Row>
                    </Flex>
                </Col >
            </Row >
        </div >
    );
};

const ParadasNoAutorizadasTotal = ({ data, onSelectParadaNoAuth, highlightedParadaNoAuth, handleFiltro }) => {
    // Agrupar alertas por evento y calcular totales
    if (!Array.isArray(data) || data.length === 0) {
        return null; // Se Evita renderizar si no hay datos
    }

    const groupedAlerts = data.reduce((acc, alert) => {
        const key = alert.tipo_alerta;
        if (!acc[key]) {
            acc[key] = { title: alert.alerta, totalAlertsEvent: 0, tipo_alerta: alert.tipo_alerta };
        }
        acc[key].totalAlertsEvent++;
        return acc;
    }, {});

    const totalAlerts = data.length; // Total global de eventos

    const formattedData = Object.values(groupedAlerts).map((event, index) => ({
        id: index,
        tipo_alerta: event.tipo_alerta,
        title: event.title,
        totalAlertsEvent: event.totalAlertsEvent,
        progress: totalAlerts > 0 ? ((event.totalAlertsEvent / totalAlerts) * 100).toFixed(1) : 0,
        color: ['primary', 'success', 'warning', 'danger', 'info'][index % 5] // Alternar colores
    }));

    // 🔹 Ordenar por cantidad de alertas (de mayor a menor)
    formattedData.sort((a, b) => b.totalAlertsEvent - a.totalAlertsEvent);

    let filteredData = null;

    if (highlightedParadaNoAuth) {
        filteredData = formattedData.filter((item) => item.tipo_alerta == highlightedParadaNoAuth)
    }

    return (
        <Card className="h-100">
            <FalconCardHeader
                title={highlightedParadaNoAuth ? `Total de paradas No Autorizadas: ${filteredData[0].title}` : "Total de paradas No Autorizadas"}
                light
                titleTag="h6"
                endEl={highlightedParadaNoAuth &&
                    (
                        <IconButton
                            onClick={handleFiltro}
                            icon="times-circle"
                            size="sm"
                            variant="falcon-default">Remover filtro
                        </IconButton>
                    )
                }
            />

            <Card.Body className="p-0">
                <div style={{ maxHeight: '250px' }}>
                    {formattedData.map((project, index) => (
                        <Project
                            project={project}
                            isLast={index === formattedData.length - 1}
                            key={project.id}
                            onSelectParadaNoAuth={onSelectParadaNoAuth}
                            highlighted={highlightedParadaNoAuth === project.tipo_alerta} // 🚀 Destacar evento seleccionado
                        />
                    ))}
                </div>
            </Card.Body>

            <Card.Footer className='py-2'>
                <Row className='justify-content-end text-end border-top border-200 pt-2'>
                    <div className="fw-bold label-detail-card">Total: {(totalAlerts).toLocaleString('es-MX')}</div>
                </Row>
            </Card.Footer>
        </Card>
    );
};

Project.propTypes = {
    project: PropTypes.shape({
        totalAlertsEvent: PropTypes.number.isRequired, // Total por evento
        tipo_alerta: PropTypes.string.isRequired, //iud alerta
        title: PropTypes.string.isRequired, //Nombre del evento
        progress: PropTypes.string.isRequired,
        color: PropTypes.string.isRequired,
    }),
    isLast: PropTypes.bool
};

ParadasNoAutorizadasTotal.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({
        tipo_alerta: PropTypes.string.isRequired
    })).isRequired,
    onSelectParadaNoAuth: PropTypes.func.isRequired, // 📌 Nueva función para seleccionar eventos
    highlightedParadaNoAuth: PropTypes.string // 📌 Estado de evento seleccionada
};

export default ParadasNoAutorizadasTotal;